import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const brandInfoStyles = {
    '.content-sidebyside': {
        display: 'flex',
        flexDirection: 'column',
        padding: `0 ${pxToRem(15)}`,
        [`@media (min-width: ${size.md})`]: {
            flexDirection: 'row',
            gap: pxToRem(40),
            marginTop: pxToRem(80),
            marginBottom: pxToRem(80)
        },
        '.content-sidebyside__tile': {
            flex: 1,
            '.content-sidebyside__title': {
                h4: {
                    fontSize: pxToRem(20),
                    textTransform: 'capitalize',
                    letterSpacing: pxToRem(1.15),
                    marginTop: pxToRem(30),
                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(26)
                    }
                }
            },
            '.content-sidebyside__button': {
                marginTop: pxToRem(30)
            }
        }
    },

    '.landing-button': {
        fontSize: pxToRem(14),
        textTransform: 'uppercase',
        fontWeight: 600,
        padding: `${pxToRem(14)} ${pxToRem(12)}`,
        marginBottom: pxToRem(20),
        width: '100%',
        display: 'block',
        textAlign: 'center',
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(14),
            width: 'fit-content'
        }
    },

    '.checkerboard__tile': {
        display: 'flex',
        padding: `0 ${pxToRem(15)}`,
        alignItems: 'center',
        flexDirection: 'column',
        [`@media (min-width: ${size.md})`]: {
            flexDirection: 'row',
            margin: `${pxToRem(60)} 0`
        },
        '.checkerboard__content': {
            [`@media (min-width: ${size.md})`]: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingLeft: pxToRem(50)
            },
            '.checkerboard__body': {
                p: {
                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(18),
                        letterSpacing: pxToRem(1)
                    }
                }
            }
        },
        '.checkerboard__title': {
            position: 'relative',
            marginTop: pxToRem(20),
            h4: {
                fontSize: pxToRem(30),
                fontWeight: 'bold',
                color: 'cav_light_black',
                marginTop: pxToRem(4),
                textTransform: 'uppercase',
                letterSpacing: 'normal',
                [`@media (min-width: ${size.md})`]: {
                    fontSize: pxToRem(36)
                },
                '.checkerboard__subtitle': {
                    display: 'block',
                    fontSize: pxToRem(14),
                    color: 'cav_light_black',
                    letterSpacing: 'normal',
                    textAlign: 'center',
                    marginBottom: pxToRem(10)
                }
            }
        }
    },

    '.html-slot-container ': {
        p: {
            margin: `${pxToRem(12)} 0`
        }
    }
}
